export default __webpack_public_path__ + "static/media/nexity-policy-pl.8ddd6c6a.pdf";